if (!customElements.get('delivery-estimator')) {
  customElements.define('delivery-estimator', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.tabs = Array.from(this.querySelectorAll('[data-method]'));
      this.orderOutput = this.querySelector('[data-order-date]');
      this.deliveryOutput = this.querySelector('[data-delivery-date]');
      this.workingDaysOnly = this.dataset.workingDays === 'true';
      this.locale = this.dataset.locale || 'en-GB';

      if (!this.tabs.length || !this.orderOutput || !this.deliveryOutput) return;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.update(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
        this.getRange(tab);
      });

      const initial = this.tabs.find((tab) => tab.dataset.method === this.dataset.defaultMethod) || this.tabs[0];
      this.update(initial);
    }

    atNoon(date) {
      const copy = new Date(date);
      copy.setHours(12, 0, 0, 0);
      return copy;
    }

    addDeliveryDays(start, amount) {
      const result = this.atNoon(start);
      let added = 0;

      while (added < amount) {
        result.setDate(result.getDate() + 1);
        if (!this.workingDaysOnly || (result.getDay() !== 0 && result.getDay() !== 6)) added += 1;
      }

      return result;
    }

    shortMonth(date) {
      return new Intl.DateTimeFormat(this.locale, { month: 'short' }).format(date).replace('.', '');
    }

    formatSingleDate(date) {
      return `${date.getDate()} ${this.shortMonth(date)}`;
    }

    formatRange(start, end) {
      const sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
      const sameYear = start.getFullYear() === end.getFullYear();

      if (sameMonth) return `${start.getDate()}–${end.getDate()} ${this.shortMonth(end)}`;
      if (sameYear) return `${start.getDate()} ${this.shortMonth(start)}–${end.getDate()} ${this.shortMonth(end)}`;
      return `${start.getDate()} ${this.shortMonth(start)} ${start.getFullYear()}–${end.getDate()} ${this.shortMonth(end)} ${end.getFullYear()}`;
    }

    getRange(tab) {
      const minimum = Math.max(0, Number.parseInt(tab.dataset.min, 10) || 0);
      const maximum = Math.max(minimum, Number.parseInt(tab.dataset.max, 10) || minimum);
      const daysOutput = tab.querySelector('[data-days-text]');
      if (daysOutput) daysOutput.textContent = `${minimum}–${maximum} days`;
      return { minimum, maximum };
    }

    update(tab, focusTab = false) {
      const today = this.atNoon(new Date());
      const { minimum, maximum } = this.getRange(tab);
      const firstDate = this.addDeliveryDays(today, minimum);
      const lastDate = this.addDeliveryDays(today, maximum);

      this.tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });

      this.orderOutput.textContent = this.formatSingleDate(today);
      this.orderOutput.dateTime = today.toISOString().slice(0, 10);
      this.deliveryOutput.textContent = this.formatRange(firstDate, lastDate);
      this.deliveryOutput.dateTime = `${firstDate.toISOString().slice(0, 10)}/${lastDate.toISOString().slice(0, 10)}`;

      if (focusTab) tab.focus();
    }

    handleKeydown(event, index) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();

      let nextIndex = index;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      this.update(this.tabs[nextIndex], true);
    }
  });
}